// src/com/bulk_company_products/BulkCompanyProductsGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * BULK_COMPANY_PRODUCTS Apollo Graphql
 * 벌크상품에 업체를 매핑
 * Project: NewTOP for cloud
 * 2025-01-09 16:02:48 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const BULK_COMPANY_PRODUCTS_LIST_PART = gql`
fragment BulkCompanyProductsListPart on BulkCompanyProducts {
    bulkCompanyId
    bulkProductsId
    comName
    prodName
    useCompanyYn
    useProductYn
}
`;

// 실무 사용
// useCompanyYn=Y AND useProductYn=Y인 목록만 조회
export const LIST_BULK_COMPANY_PRODUCTS = gql`
${BULK_COMPANY_PRODUCTS_LIST_PART}
query ListBulkCompanyProducts($bulkCompanyId:Int, $bulkProductsId:Int) {
    bulkCompanyProductsList(bulkCompanyId:$bulkCompanyId, bulkProductsId:$bulkProductsId) {
        ...BulkCompanyProductsListPart
    }
}
`;

// 관리용.
// bulkCompanyProductsListAll(bulkCompanyId:Int, bulkProductsId:Int): [BulkCompanyProducts]!
export const LIST_ALL_BULK_COMPANY_PRODUCTS = gql`
${BULK_COMPANY_PRODUCTS_LIST_PART}
query ListAllBulkCompanyProducts($bulkCompanyId:Int, $bulkProductsId:Int) {
    bulkCompanyProductsListAll(bulkCompanyId:$bulkCompanyId, bulkProductsId:$bulkProductsId) {
        ...BulkCompanyProductsListPart
    }
}
`;

/**
 * 목록을 상품을 상위, 업체를 하위로하는 2개 트리 구조로 변환
 * @param {*} list 
 */
/* export function makeTwoBulkProductsCompanyTrees(list) {
    const tree = {};
    list.forEach(item => {
        if(!tree[item.bulkProductsId]) {
            tree[item.bulkProductsId] = {
                bulkProductsId:item.bulkProductsId,
                prodName:item.prodName,
                companies:[]
            };
        }
        tree[item.bulkProductsId].companies.push({
            bulkCompanyId:item.bulkCompanyId, comName:item.comName,
            bulkProductsId:item.bulkProductsId
        });
    });
    const treeVal = Object.values(tree);
    treeVal.forEach((prod) => {
        prod.companies.sort((a, b) => a.comName - b.comName);
    });
    treeVal.sort((a, b) => a.bulkProductsId - b.bulkProductsId);
    // 상품을 2개 그룹으로 나누기 - 각 그룹의 업체수가 비슷하도록
    const counts = treeVal.map(prod => prod.companies.length);
    let mid = 1;
    while(mid < counts.length-1) {
        const sumLeft = counts.slice(0, mid).reduce((a, b) => a + b, 0);
        const sumRight = counts.slice(mid).reduce((a, b) => a + b, 0);
        const diff = Math.abs(sumLeft - sumRight);
        const nextDiff = Math.abs(sumLeft + counts[mid] - (sumRight - counts[mid]));
        if(diff < nextDiff) {
            break;
        }
        mid++;
    }
    const twoTree = [
        treeVal.slice(0, mid),
        treeVal.slice(mid)
    ];
    return twoTree;
} */

/**
 * 지정한 상품을 어떤 업체들이 공급하고 있는지 배열로 반환
 * @param {*} bulkProductsId 상품아이디
 * @param {*} list bulkCompanyProductsListAll 데이터 배열
 */
export function getCompaniesUsingProduct(bulkProductsId, list) {
    const coms = [];
    list.forEach(item => {
        if(item.bulkProductsId === bulkProductsId) {
            coms.push(item.comName);
        }
    });
    return coms;
}

/**
 * 지정한 업체가 어떤 상품들을 공급하고 있는지 배열로 반환
 * @param {*} bulkCompanyId 업체아이디
 * @param {*} list bulkCompanyProductsListAll 데이터 배열
 * @returns 상품 이름 배열
 */
export function getProductsOfCompany(bulkCompanyId, list) {
    const prods = [];
    list.forEach(item => {
        if(item.bulkCompanyId === bulkCompanyId) {
            prods.push(item.prodName);
        }
    });
    return prods;
}

function getCountOfBulkItems(bulkItemsList, bulkCompanyId, bulkProductsId) {
    const bulkItem = bulkItemsList.find(item => item.bulkCompanyId === bulkCompanyId && item.bulkProductsId === bulkProductsId);
    if(bulkItem) {
        return bulkItem.quantity;
    }
    return 0;
}

/**
 * 목록을 상품을 상위, 업체를 하위로하는 2개 트리 구조로 변환.
 * bulkItemsList의 quantity값을 업체별로 매핑하여 트리 구조에 포함시킴.
 * @param {*} list 
 * @param {*} bulkItemsList
 */
export function mergeBulkCountAndMakeTwoBulkProductsCompanyTrees(list, bulkItemsList) {
    const leftGroups = ['양곡', '화장지', '음료','라면&햇반', '시그니쳐', 'PBS', '기타'];
    const rightGroups = ['선물세트(경유)','선물세트(비축)'];
    // If not in leftGroups and not in rightGroups, put in rightGroups.

    // 상품을 상위, 업체를 하위로하는 트리 구조로 변환
    const tree = {};
    list.forEach(item => {
        if(!tree[item.bulkProductsId]) {
            tree[item.bulkProductsId] = {
                bulkProductsId:item.bulkProductsId,
                prodName:item.prodName,
                companies:[]
            };
        }
        tree[item.bulkProductsId].companies.push({
            bulkCompanyId:item.bulkCompanyId,
            comName:item.comName,
            bulkProductsId:item.bulkProductsId,
            quantity: getCountOfBulkItems(bulkItemsList, item.bulkCompanyId, item.bulkProductsId)
        });
        if(!leftGroups.includes(item.prodName) && !rightGroups.includes(item.prodName)) {
            rightGroups.push(item.prodName);
        }
    });
    // 좌우 그룹으로 나누기.
    const leftTree = [];
    const rightTree = [];

    Object.values(tree).forEach(prod => {
        // 업체를 이름순으로 정렬. 단, 업체명이 '기타'이면 마지막으로 보내기.
        prod.companies.sort((a, b) => {
            if(a.comName === '기타') return 1;
            if(b.comName === '기타') return -1;
            return a.comName.localeCompare(b.comName);
        });
        if(leftGroups.includes(prod.prodName)) {
            leftTree.push(prod);
        }
        else {
            rightTree.push(prod);
        }
    });
    // 각 상품트리를 그룹이름 순으로 정렬
    leftTree.sort((a, b) => leftGroups.indexOf(a.prodName) - leftGroups.indexOf(b.prodName));
    rightTree.sort((a, b) => rightGroups.indexOf(a.prodName) - rightGroups.indexOf(b.prodName));

    // 상품을 2개 그룹으로 나누기 - 각 그룹의 업체수가 비슷하도록
    /* 
    const treeVal = Object.values(tree);
    treeVal.forEach((prod) => {
        prod.companies.sort((a, b) => a.comName - b.comName);
    });
    treeVal.sort((a, b) => a.bulkProductsId - b.bulkProductsId);const counts = treeVal.map(prod => prod.companies.length);
    let mid = 1;
    while(mid < counts.length-1) {
        const sumLeft = counts.slice(0, mid).reduce((a, b) => a + b, 0);
        const sumRight = counts.slice(mid).reduce((a, b) => a + b, 0);
        const diff = Math.abs(sumLeft - sumRight);
        const nextDiff = Math.abs(sumLeft + counts[mid] - (sumRight - counts[mid]));
        if(diff < nextDiff) {
            break;
        }
        mid++;
    } */
    return [
        leftTree,
        rightTree
    ];;
}

export const GET_BULK_COMPANY_PRODUCTS = gql`
${BULK_COMPANY_PRODUCTS_LIST_PART}
query GetBulkCompanyProducts($bulkCompanyId:Int!, $bulkProductsId:Int!) {
    bulkCompanyProductsItem(bulkCompanyId:$bulkCompanyId, bulkProductsId:$bulkProductsId) {
        ...BulkCompanyProductsListPart
    }
}
`;

export const ADD_BULK_COMPANY_PRODUCTS = gql`
mutation AddBulkCompanyProducts($bulkCompanyProducts:InputBulkCompanyProductsAdd!) {
	bulkCompanyProductsAdd(bulkCompanyProducts: $bulkCompanyProducts) {
		ok
		message
	}
}
`;

export const REMOVE_BULK_COMPANY_PRODUCTS = gql`
mutation RemoveBulkCompanyProducts($bulkCompanyProducts:InputBulkCompanyProductsRemove!) {
	bulkCompanyProductsRemove(bulkCompanyProducts: $bulkCompanyProducts) {
		ok
		message
	}
}
`;
